import { FC } from 'react';

import useTrls from 'hooks/translation/useTrls';

const VacancyId: FC<{ vacancyId: string }> = ({ vacancyId }) => {
    const trl = useTrls();

    if (!vacancyId) {
        return null;
    }

    return (
        <p>
            {trl('campaign.targetings.vacancyId.item')}: {vacancyId}
        </p>
    );
};

export default VacancyId;
